// Adapted from this example:
// https://stackoverflow.com/a/3955258

// Helpful resources:
// - GOOGLE OVERLAY DOCS: https://developers.google.com/maps/documentation/javascript/customoverlays#javascript
// - GOOGLE MAPS JAVASCRIPT API V3 REFERENCE: https://developers.google.com/maps/documentation/javascript/reference

/**
 * DESCRIPTION:
 * This Class handles placing duplicate marker count "labels" on the map.
 *
 * HISTORY:
 * We previously used the InfoBox Class to provide this functionality.(/js/lib/infobox.js)
 * This use of InfoBox came at a large peformance cost relative to the use case.
 *
 * NOTES:
 * The TxtOverlay Class leverages the google maps custom overlay 'overlayLayer' pane to place labels on the map
 * without needing to apply any listeners or additional logic to accomplish the rendering/drawing.
 * The 'overlayLayer' pane can not recieve DOM events, which is fine for our current use case.
 *
 */

(function (window) {
  /**
   * Essentially a constructor for our "Class"
   *
   * @param {object} latLngPosition - An instance of google.maps.LatLng().
   * @param {string} textToDisplay - A string literal or string of HTML elements/nodes.
   * @param {string} className - CSS/SCSS class to apply to the overlay elements/nodes.
   * @param {Google.map} map - An instance of google.maps.Map().
   * @param {object} pixelOffset - An object containing a width(INT) and height(INT) 'Key:Value' pair.
   */
  function TxtOverlay(
    latLngPosition,
    textToDisplay,
    className,
    map,
    pixelOffset = { width: 0, height: 0 },
    customEventData = null,
  ) {
    // Initialize all properties.
    this.latLngPosition = latLngPosition;
    this.textToDisplay_ = textToDisplay;
    this.className_ = className;
    this.pixelOffset_ = pixelOffset;
    this.map_ = map;
    this.customEventData = customEventData;
    this.customEvent;
    this.hasRenderedBefore = false;

    // We define a property to hold the container
    // div. We'll actually create this div
    // upon receipt of the add() method so we'll
    // leave it null for now.
    this.div_ = null;

    // Explicitly call setMap() on this overlay
    this.setMap(map);
  }

  // "Tie" this new "Class" to the overlayView. This is like 'extends' on a Class.
  TxtOverlay.prototype = new google.maps.OverlayView();

  // Note: an overlay's receipt of onAdd() indicates that
  // the map's panes are now available for attaching
  // the overlay to the map via the DOM.
  TxtOverlay.prototype.onAdd = function () {
    // Create the DIV and set relavent attributes.
    var div = document.createElement("DIV");
    div.className = this.className_;
    div.innerHTML = this.textToDisplay_;

    if (this.customEventData) {
      const { title, callback } = this.customEventData;
      this.customEvent = new Event(title);
      div.addEventListener(title, callback);
    }

    // Set the overlay's div_ property to this DIV
    this.div_ = div;
    var overlayProjection = this.getProjection();
    var position = overlayProjection.fromLatLngToDivPixel(this.latLngPosition);
    div.style.left = position.x + this.pixelOffset_.width + "px";
    div.style.top = position.y + this.pixelOffset_.height + "px";

    // We add an overlay to a map via one of the map's panes.
    var panes = this.getPanes();
    panes.overlayLayer.appendChild(div);
  };

  // called whenever the map zoom/drag changes
  // handles placing the overlay on the map and the divs
  TxtOverlay.prototype.draw = function () {
    var overlayProjection = this.getProjection();

    // Retrieve the southwest and northeast coordinates of this overlay
    // in latlngs and convert them to pixels coordinates.
    // We'll use these coordinates to resize the DIV.
    var position = overlayProjection.fromLatLngToDivPixel(this.latLngPosition);

    var div = this.div_;
    div.style.left = position.x + this.pixelOffset_.width + "px";
    div.style.top = position.y + this.pixelOffset_.height + "px";
    div.style.position = "absolute";

    // if a custom event exists, and this is the first time drawing the marker
    // we fire an event so the map knows now is a good time to clean up labels
    // if necessary. This handles an edge case in which the hide() method is
    // called before labels are added to the map.
    if (this.customEvent && !this.hasRenderedBefore) {
      this.hasRenderedBefore = true;
      div.dispatchEvent(this.customEvent);
    }
  };

  //Optional: helper methods for removing and toggling the text overlay.
  TxtOverlay.prototype.onRemove = function () {
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  };

  TxtOverlay.prototype.hide = function () {
    if (this.div_) this.div_.style.visibility = "hidden";
  };

  TxtOverlay.prototype.show = function () {
    if (this.div_) this.div_.style.visibility = "visible";
  };

  TxtOverlay.prototype.toggle = function () {
    if (this.div_) {
      if (this.div_.style.visibility == "hidden") {
        this.show();
      } else {
        this.hide();
      }
    }
  };

  TxtOverlay.prototype.toggleDOM = function () {
    if (this.getMap()) {
      this.setMap(null);
    } else {
      this.setMap(this.map_);
    }
  };

  // append to window for public api
  window.TxtOverlay = TxtOverlay;
})(window);

// EXAMPLE.
/*
    var map;
    var txtOverlay;
    function init() {
        var latlng = new google.maps.LatLng(37.9069, -122.0792);
        var myOptions = {
            zoom: 4,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        map = new google.maps.Map(document.getElementById("map"), myOptions);

        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            title: "Hello World!"
        });

        var customTxt = "Test Overlay"; //customTxt can be a string or HTML Element/Node
        txtOverlay = new TxtOverlay(latlng, customTxt, "customBox", map);
    }
*/
